// The authenticated portal app's origin per environment. Single source for getPortalUrl()
// (getEnvironments.js), the public planner's "Open in Chain.io" link
// (public-layout-builder/publicConfig.js) and the claim dialog's rejection of portal links
// (parseLayoutReference.js). Dependency-free on purpose: the public, unauthenticated
// bundle imports it, so it must never pull in auth, localStorage or app config.
export const PORTAL_APP_URLS_BY_ENV = {
  test: 'http://localhost:3000',
  red: 'https://red-portal.chain.io',
  production: 'https://portal.chain.io'
}

// Hostnames only (no port): a portal hostname on any port still names the portal.
export const PORTAL_APP_HOSTNAMES = Object.values(PORTAL_APP_URLS_BY_ENV).map(url => new URL(url).hostname)
